module.exports = __webpack_public_path__ + "media/images/favicons/favicon-d666c6899acc83e2d7d9973c0f2a7a70.ico";